<template>
  <main>
    <div
      style="position: fixed; top: 20px; z-index: 4; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="dashboardAdmin-parentdiv bluebtn" style="background: #f3f3f3">
      <div class="dashboardAdmin-header mt-4 dashboardAdmin-header-main-head">
        Transactions
      </div>

      <div class="relativeclass transaction-container my-3 px-1">
        <div class="d-flex align-items-center w-100 gap-15 overflow-x-class">
          <div class="relativeclass transac-cards transac-cards-selected">
            <div class="setfirst-img">
              <img src="../../assets/img/transactions/one.svg.svg" alt="" />
            </div>
            <div class="h-one" style="place-content: center">
              <img src="../../assets/img/transactions/cash.svg" alt="" />
            </div>
            <div class="selected-green-text h-two">
              ₹{{ transactionStat.creditSpent }}
            </div>
            <div class="selected-small-text h-two">Total Spendings</div>
          </div>

          <div class="relativeclass transac-cards">
            <div class="setsecond-img">
              <img src="../../assets/img/transactions/third.svg" alt="" />
            </div>
            <div class="h-one" style="place-content: center">
              <img src="../../assets/img/transactions/chat.svg" alt="" />
            </div>
            <div class="head-text h-two">
              {{ transactionStat.totalInterviewCount }}
            </div>
            <div class="subhead-text h-two">Total Interviews</div>
          </div>
          <div class="big-line"></div>
          <div class="relativeclass transac-cards">
            <div class="h-one" style="place-content: center">
              <div class="yellow-card">highest interviews taken</div>
            </div>
            <div class="h-two">
              <div class="blue-card">
                Customer: {{ transactionStat.topCustomer.name }}
              </div>
            </div>
            <div class="head-text h-two d-flex gap-15">
              <div class="light-yellow-card">
                Interviews: {{ transactionStat.topCustomer.interviewCount }}
              </div>
              <div class="light-yellow-card">
                Jobs: {{ transactionStat.topCustomer.jobCount }}
              </div>
            </div>
          </div>
          <div>
            <div
              class="relativeclass transac-cards"
              @mouseenter="showTooltipPlace = true"
              @mouseleave="showTooltipPlace = false"
              :style="
                !roles.includes('HIRE3X_WALLET') &&
                'opacity: 0.6;  cursor: default;'
              "
            >
              <div class="setsecond-img">
                <img src="../../assets/img/transactions/fourth.svg" alt="" />
              </div>
              <div class="h-one" style="place-content: center">
                <img src="../../assets/img/transactions/Credit.svg" alt="" />
              </div>
              <div class="creadits-head h-two">Add Credits</div>
              <div
                class="
                  credits-subhead
                  h-two
                  d-flex
                  justify-content-between
                  w-100
                "
              >
                <div>Go to Hire3x Wallet to withdraw your funds.</div>
                <div>
                  <img
                    :class="roles.includes('HIRE3X_WALLET') && 'pointer'"
                    src="../../assets/img/transactions/transac-right-arrow.svg"
                    alt=""
                    @click="
                      roles.includes('HIRE3X_WALLET') ? openAddCredit() : ''
                    "
                  />
                </div>
              </div>
            </div>
            <div
              v-if="showTooltipPlace && !roles.includes('HIRE3X_WALLET')"
              class="cs-tooltip-place tooltip-pos"
            >
              <div class="mt-1">You don't have access to Hire3x Wallet</div>
            </div>
          </div>
        </div>

        <div class="mt-3 transac-main-table">
          <div class="transac-main-head">Interviews</div>

          <div
            class="mt-3 d-flex align-items-center justify-content-between w-100"
          >
            <div class="relativeclass teams-innerInputField w-30">
              <img
                class="teams-setImage"
                src="../../assets/img/search-bar-icon.svg"
                alt=""
              />

              <b-form-input
                placeholder="Search"
                type="search"
                class="search-input"
                v-model.trim="searchQuery"
                @input="textSearch"
                @keyup="textSearch"
              >
              </b-form-input>
            </div>
            <div class="d-flex align-items-center gap-15">
              <div
                ref="filterClosable"
                v-closable="{
                  exclude: ['filterClosable', 'filterClosableDropdown'],
                  handler: 'closeFilterDropdown',
                }"
                class="position-relative"
              >
                <div :class="{ 'cv-filter-dot': isFiltered }"></div>
                <b-button
                  class="acs-addBtn-modal"
                  @click="toggleFilterDropdown"
                >
                  <img
                    class="mr-2"
                    src="../../assets/img/accessconnew/whiteFilter.svg"
                    alt=""
                  />Filter
                </b-button>
                <div
                  class="filter-popup"
                  v-if="showFilterDropdown"
                  ref="filterClosableDropdown"
                >
                  <div class="mt-2">
                    <div class="acs-black-txt">Status:</div>
                    <div
                      @click="statusToggle = !statusToggle"
                      class="acs-filter-dropdown mt-2 position-relative pointer"
                    >
                      <span class="newManage-dropdown-place">
                        {{
                          statusFilter === "" || statusFilter === null
                            ? "All"
                            : statusFilter == 1
                            ? "Pending"
                            : statusFilter == 0
                            ? "Cancelled"
                            : statusFilter == 2
                            ? "Completed"
                            : "Rejected"
                        }}
                      </span>
                      <img
                        src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                        alt=""
                      />
                    </div>
                    <div v-if="statusToggle" class="relativeclass">
                      <div class="newInt-radio-dropdown p-0">
                        <b-form-group class="sec-mcq-datacard">
                          <b-form-radio-group
                            class="newInt-radio-dropdown-inner-content w-100"
                            size="sm"
                            v-model="statusFilter"
                            :options="statusOptions"
                            @change="statusToggle = false"
                            buttons
                            stacked
                          ></b-form-radio-group>
                        </b-form-group>
                      </div>
                    </div>
                  </div>

                  <!-- Filter buttons -->
                  <div class="d-flex justify-content-between mt-3">
                    <b-button class="acs-cancelBtn-filter" @click="resetFilters"
                      >Reset</b-button
                    >
                    <b-button class="acs-cancelBtn-filter" @click="applyFilters"
                      >Apply</b-button
                    >
                  </div>
                </div>
              </div>
              <!-- <b-button class="acs-addBtn-modal" @click="getTransactions(true)"
                >Export Excel</b-button
              > -->
              <article class="position-relative">
                <div
                  style="top: 35px"
                  class="filter-popup"
                  v-if="showExportFilter"
                  ref="closeCard"
                >
                  <div ref="recdropdown1">
                    <div class="export-modal-content">
                      <div>
                        <label class="teams-label-font fs-14 my-2 w-40"
                          >From Date :</label
                        >
                        <DateField
                          :mandatory="false"
                          :placeholder="'From Date'"
                          :noLabel="true"
                          format="DD-MM-YYYY"
                          :id="'start-date-disable'"
                          :vmodel="fromDate"
                          @select-value="updateFromDate"
                          :startDate="null"
                        />
                        <label class="teams-label-font fs-14 mb-2 mt-3 w-40"
                          >To Date :</label
                        >
                        <DateField
                          :mandatory="false"
                          :placeholder="'To Date'"
                          :noLabel="true"
                          format="DD-MM-YYYY"
                          :id="'to-date-special'"
                          :vmodel="toDate"
                          @select-value="updateToDate"
                          :startDate="fromDate"
                        />
                      </div>
                    </div>

                    <div class="d-flex justify-content-between mt-3 bluebtn">
                      <b-button
                        class="acs-cancelBtn-filter"
                        @click="closeExportFilter"
                        >Cancel</b-button
                      >
                      <b-button
                        class="acs-addBtn-filter"
                        :disabled="!fromDate || !toDate"
                        @click="applyExportFilter"
                        >Export</b-button
                      >
                    </div>
                  </div>
                </div>

                <b-button
                  @click="showExportFilter = !showExportFilter"
                  class="acs-addBtn-modal"
                  ref="excelButton"
                  >Export Excel</b-button
                >
              </article>
            </div>
          </div>
          <div class="mt-3 transac-main-inner-table">
            <div class="transac-table-head">
              <!-- add filter f -->
              <div class="w-15 pl-4">
                Customer Name
                <img
                  v-if="sortOrder.customerName === 'desc'"
                  class="pointer"
                  @click="sortTable('customerName')"
                  src="../../assets/img/transactions/downsort.svg"
                  alt="Sort Icon"
                />
                <img
                  v-if="sortOrder.customerName === 'asc'"
                  class="pointer"
                  @click="sortTable('customerName')"
                  src="../../assets/img/transactions/upsort.svg"
                  alt="Sort Icon"
                />
                <img
                  v-if="sortOrder.customerName === 'nosort'"
                  class="pointer"
                  @click="sortTable('customerName')"
                  src="../../assets/img/transactions/nosort.svg"
                  alt="Sort Icon"
                />
              </div>
              <div class="w-10">
                Job Name
                <img
                  v-if="sortOrder.jobName == 'desc'"
                  class="pointer"
                  @click="sortTable('jobName')"
                  src="../../assets/img/transactions/downsort.svg"
                  alt="Sort Icon"
                />
                <img
                  v-if="sortOrder.jobName == 'asc'"
                  class="pointer"
                  @click="sortTable('jobName')"
                  src="../../assets/img/transactions/upsort.svg"
                  alt="Sort Icon"
                />
                <img
                  v-if="sortOrder.jobName == 'nosort'"
                  class="pointer"
                  @click="sortTable('jobName')"
                  src="../../assets/img/transactions/nosort.svg"
                  alt="Sort Icon"
                />
              </div>
              <div class="w-10">
                Candidate Name
                <img
                  v-if="sortOrder.name == 'desc'"
                  class="pointer"
                  @click="sortTable('name')"
                  src="../../assets/img/transactions/downsort.svg"
                  alt="Sort Icon"
                />
                <img
                  v-if="sortOrder.name == 'asc'"
                  class="pointer"
                  @click="sortTable('name')"
                  src="../../assets/img/transactions/upsort.svg"
                  alt="Sort Icon"
                />
                <img
                  v-if="sortOrder.name == 'nosort'"
                  class="pointer"
                  @click="sortTable('name')"
                  src="../../assets/img/transactions/nosort.svg"
                  alt="Sort Icon"
                />
              </div>
              <div class="w-10">
                Recruiter Name
                <img
                  v-if="sortOrder.recruiter == 'desc'"
                  class="pointer"
                  @click="sortTable('recruiter')"
                  src="../../assets/img/transactions/downsort.svg"
                  alt="Sort Icon"
                />
                <img
                  v-if="sortOrder.recruiter == 'asc'"
                  class="pointer"
                  @click="sortTable('recruiter')"
                  src="../../assets/img/transactions/upsort.svg"
                  alt="Sort Icon"
                />
                <img
                  v-if="sortOrder.recruiter == 'nosort'"
                  class="pointer"
                  @click="sortTable('recruiter')"
                  src="../../assets/img/transactions/nosort.svg"
                  alt="Sort Icon"
                />
              </div>
              <div class="w-20">
                Round Number, Name
                <img
                  v-if="sortOrder.interviewLevel == 'desc'"
                  class="pointer"
                  @click="sortTable('interviewLevel')"
                  src="../../assets/img/transactions/downsort.svg"
                  alt="Sort Icon"
                />
                <img
                  v-if="sortOrder.interviewLevel == 'asc'"
                  class="pointer"
                  @click="sortTable('interviewLevel')"
                  src="../../assets/img/transactions/upsort.svg"
                  alt="Sort Icon"
                />
                <img
                  v-if="sortOrder.interviewLevel == 'nosort'"
                  class="pointer"
                  @click="sortTable('interviewLevel')"
                  src="../../assets/img/transactions/nosort.svg"
                  alt="Sort Icon"
                />
              </div>
              <div class="w-20">Interview Date and Time</div>
              <div class="w-10">Amount</div>
              <div class="w-5 pl-1">Action</div>
            </div>
            <div class="transac-table-body" v-if="showLoader">
              <div class="transac-table-row" v-for="i in 10" :key="i">
                <b-skeleton class="w-100 h-100 mt-2"></b-skeleton>
              </div>
            </div>
            <div
              class="transac-table-body"
              v-else-if="paginatedData.length == 0"
            >
              <div
                class="
                  h-100
                  d-flex
                  justify-content-center
                  align-items-center
                  flex-column
                "
              >
                <img src="../../assets/panelist/no-trans.svg" alt />
                <div
                  v-if="searchQuery != ''"
                  class="notfoundimg mt-2 wordbreak"
                >
                  No matching results for
                  <strong> "{{ searchQuery }}" </strong>
                </div>
                <div v-else class="notfoundimg mt-2 wordbreak">
                  No data found
                </div>
              </div>
            </div>
            <div class="transac-table-body" v-else>
              <div
                class="transac-table-row"
                v-for="(data, index) in paginatedData"
                :key="index"
              >
                <div class="w-15 text-truncate pl-4">
                  {{ data.customerName }}
                </div>
                <div class="w-10 text-truncate pr-2">
                  <span v-b-tooltip.hover.bottom="data.jobName">
                    {{ data.jobName }}</span
                  >
                </div>
                <div class="w-10 text-truncate pr-2">
                  <span v-b-tooltip.hover.bottom="data.name">
                    {{ data.name }}</span
                  >
                </div>
                <div class="w-10 text-truncate pr-2">
                  <span v-b-tooltip.hover.bottom="data.recruiter">
                    {{ data.recruiter }}</span
                  >
                </div>
                <div class="w-20 text-truncate pr-2">
                  {{ data.interviewLevel }}, {{ data.interviewName }}
                </div>
                <div class="w-20">{{ data.slot }}</div>
                <div class="w-10">
                  <div
                    v-b-tooltip.hover="getToolTipText(data.paymentStatus)"
                    class="amount-card"
                  >
                    <img
                      v-if="data.paymentStatus == 1"
                      src="../../assets/img/money-icon.svg"
                      alt=""
                    />
                    <img
                      v-if="data.paymentStatus == 2"
                      src="../../assets/img/green-money-icon.svg"
                      alt=""
                    />
                    <img
                      v-if="data.paymentStatus == 3 || data.paymentStatus == 0"
                      src="../../assets/img/red-money-icon.svg"
                      alt=""
                    />
                    <span>{{ data.amount }}</span>
                  </div>
                </div>
                <div class="w-5">
                  <img
                    @click="showDetails(data)"
                    class="pl-3 pointer"
                    src="../../assets/img/accessconnew/blueEye.svg"
                    alt="/"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="paginatedData.length > 0"
              class="
                acs-paginaTion-new
                d-flex
                justify-content-between
                align-items-center
                transaction-paginaTion-new
              "
            >
              <div class="d-flex">
                <span class="acs-gotopage-text p-1 mr-2">Go to page</span>
                <b-form-input
                  autocomplete="off"
                  type="text"
                  @keypress="NumbersOnly"
                  @paste="handlePaste"
                  v-model.number="goToPage"
                  @keyup.enter="handleGoToPage"
                  class="acs-pagination-num"
                ></b-form-input>
                <div class="acs-pagination-addbtn" @click="handleGoToPage">
                  <span>
                    <img src="../../assets/panelist/page_arrow.svg" alt />
                  </span>
                </div>
              </div>

              <div class="pagination">
                <b-pagination
                  v-model="currentPage"
                  @change="handlePageChange"
                  :total-rows="total"
                  :per-page="count"
                  align="center"
                  first-number
                  last-number
                >
                  <template #prev-text>
                    <span>
                      <img
                        src="../../assets/img/accessconnew/pageleft.svg"
                        alt
                      />
                    </span>
                  </template>
                  <template #next-text>
                    <span>
                      <img
                        src="../../assets/img/accessconnew/pageright.svg"
                        alt
                      />
                    </span>
                  </template>
                </b-pagination>
              </div>
              <div class="d-flex align-items-center">
                <PageInput :pagecount="count" @update-value="updatePage" />

                <div
                  class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end"
                >
                  Showing :
                  <div
                    class="text-truncate ml-2 results-individual-width"
                    v-if="pageStart > total"
                  >
                    0
                  </div>
                  <div
                    v-else
                    class="text-truncate ml-2 results-individual-width"
                  >
                    {{ pageStart }}
                  </div>
                  <div class="text-truncate results-individual-width">-</div>
                  <div class="text-truncate results-individual-width">
                    {{ pageEnd }}
                  </div>
                  <div class="text-truncate ml-1 results-individual-width">
                    of
                  </div>
                  <div
                    class="text-truncate ml-1 results-individual-width"
                    style="max-width: 20%"
                  >
                    {{ total }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ViewDetailsModal
      v-if="showInfo"
      :showModal="showInfo"
      :detailInfo="detailInfo"
      @close-modal="closeModal"
    />
  </main>
</template>

<script>
import PageInput from "../../components/InputComponents/PaginationInput.vue";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
import ViewDetailsModal from "./ViewDetailsModal.vue";
import { getTransactions, getTansactionStat } from "../../utils/apiFunctions";
import DateField from "../../components/InputComponents/DateField.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { mapGetters } from "vuex";

export default {
  name: "Transactions",
  components: {
    PageInput,
    ViewDetailsModal,
    DateField,
    Spinner,
  },

  data() {
    return {
      showTooltipPlace: false,
      LoaderStatus: false,
      isFiltered: false,
      filterText: null,
      showFilter: false,
      fromDate: null,
      toDate: null,
      showExportFilter: false,
      sortOrder: {
        customerName: "nosort",
        jobName: "nosort",
        name: "nosort",
        recruiter: "nosort",
        interviewName: "nosort",
      },
      showLoader: false,
      searchQuery: "",
      sortByValue: false,
      total: 0,
      count: 10,
      pageStart: 1,
      currentPage: 1,
      goToPage: null,
      transactions: {},
      detailInfo: {},
      showInfo: false,
      transactionStat: { topCustomer: {} },

      showFilterDropdown: false,
      column: "",
      statusFilter: null,
      statusToggle: false,
      statusOptions: [
        { text: "All", value: "" },
        { text: "Pending", value: 1 },
        { text: "Completed", value: 2 },
        // { text: "Rejected", value: 3 },
        {
          text: "Cancelled",
          value: 0,
        },
      ],
    };
  },
  async created() {
    this.LoaderStatus = true;
    await this.getTransactions();
    await this.getTansactionStat();
    this.LoaderStatus = false;
  },
  mounted() {
    document.body.addEventListener("mousedown", this.handleClose);
  },
  beforeDestroy() {
    document.body.removeEventListener("mousedown", this.handleClose);
  },
  computed: {
    ...mapGetters(["roles"]),
    pageEnd() {
      return Math.min(this.pageStart + this.count - 1, this.total);
    },
    paginatedData() {
      return this.transactions.data || [];
    },
  },
  methods: {
    getToolTipText(status) {
      let text = "Payment ";
      let textVal =
        status == 1 ? "Pending" : status == "2" ? "Done" : "Rejected";
      return text + textVal;
    },
    handleClose(event) {
      if (!event) return;
      if (
        this.$refs.closeCard &&
        !this.$refs.closeCard?.contains(event.target) &&
        !this.$refs.excelButton?.contains(event.target) &&
        !document
          .getElementsByClassName("mx-calendar")[0]
          ?.contains(event.target)
      ) {
        this.closeExportFilter();
      }
    },
    async getTansactionStat() {
      const response = await getTansactionStat();
      if (response.status == 200) {
        this.transactionStat = response.data.data;
      }
    },
    closeExportFilter() {
      this.resetExportFilter();
      this.showExportFilter = false;
    },
    closeFilter() {
      this.showExportFilter = false;
    },
    resetExportFilter() {
      this.fromDate = null;
      this.toDate = null;
    },
    applyExportFilter() {
      this.getTransactions(true);
      this.closeExportFilter();
    },

    updateFromDate(date) {
      this.fromDate = date;
      console.log("date", this.fromDate);
    },
    updateToDate(date) {
      this.toDate = date;
    },
    openAddCredit() {
      window.open("https://utility.hire3x.com", "_blank");
    },
    handlePaste(event) {
      const clipboardData = event.clipboardData;
      const pastedData = clipboardData.getData("Text");

      if (!/^\d*$/.test(pastedData)) {
        event.preventDefault();
      } else {
        this.goToPage = pastedData.replace(/\D/g, "");
      }
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    updatePage(page) {
      this.count = page;
      this.currentPage = 1;
      this.getTransactions();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.getTransactions();
    },
    handleGoToPage() {
      if (
        this.goToPage &&
        this.goToPage > 0 &&
        this.goToPage <= Math.ceil(this.total / this.count)
      ) {
        this.currentPage = this.goToPage;
        this.getTransactions();
      } else {
        this.goToPage = null;
      }
    },
    textSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.page = 1;
        this.currentPage = 1;
        this.goToPage = null;
        this.pageEnd = 0;
        this.pageStart = 0;
        this.getTransactions();
      }, 400);
    },
    sortTable(value) {
      if (this.sortOrder[value] === "asc") {
        this.sortOrder[value] = "desc";
        this.sortByValue = false;
      } else if (this.sortOrder[value] === "desc") {
        this.sortOrder[value] = "nosort";
        this.sortByValue = null;
      } else {
        this.sortOrder[value] = "asc";
        this.sortByValue = true;
      }
      this.column = value;
      this.currentPage = 1;
      this.getTransactions();
    },
    showDetails(data) {
      this.detailInfo = data;
      this.showInfo = true;
    },
    closeModal() {
      this.showInfo = false;
    },
    async getTransactions(downloadFile = false) {
      this.showLoader = !downloadFile ? true : false;
      let payload = {};
      console.log("downloadFile", downloadFile);
      if (downloadFile) {
        payload = {
          excel: downloadFile,
          startDate: this.fromDate.replace(/-/g, "."),
          endDate: this.toDate.replace(/-/g, "."),
          transaction: true,
          count: this.total,
        };
      } else {
        payload = {
          excel: this.downloadFile,
          page: this.currentPage - 1,
          count: this.count,
          searchQuery: this.searchQuery,
        };

        if (this.column && this.sortByValue !== null) {
          payload.sortBy = {
            column: this.column,
            order: this.sortByValue ? 1 : -1,
          };
        }

        if (this.statusFilter !== null && this.statusFilter !== "") {
          payload.filters = {
            paymentStatus: this.statusFilter,
          };
        }
      }

      const res = await getTransactions(payload);
      if (res.status == 200) {
        if (downloadFile) {
          console.log("the response is", JSON.stringify(res.data));
          const href = URL.createObjectURL(res.data);

          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", `Panelist Reports.xlsx`);

          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          return;
        }
        this.transactions = res.data.data;
        this.total = res.data.data.total || 0;
        this.pageStart = (this.currentPage - 1) * this.count + 1;
        this.showLoader = false;
      }
    },

    // Filter related methods
    toggleFilterDropdown() {
      this.showFilterDropdown = !this.showFilterDropdown;
      this.statusToggle = false;
    },
    closeFilterDropdown() {
      this.showFilterDropdown = false;
      this.statusToggle = false;
    },
    resetFilters() {
      this.isFiltered = false;
      this.showFilterDropdown = false;
      this.statusFilter = "";
      this.getTransactions();
    },
    applyFilters() {
      this.showFilterDropdown = false;
      this.currentPage = 1;
      //find the selected text
      this.filterText = this.statusOptions.find(
        (option) => option.value === this.statusFilter
      ).text;
      this.filterText == "All"
        ? (this.isFiltered = false)
        : (this.isFiltered = true);
      this.getTransactions();
    },
  },
};
</script>

<style scoped>
.no-tran-height {
  height: calc(100vh - 470px);
  min-height: 300px;
}

.transaction-container {
  height: calc(100vh - 180px);
  overflow: hidden;
}

.transac-cards {
  box-shadow: 0px 4px 20px 0px #c4c4c480;
  background: #fff;
  border-radius: 8px;
  padding: 10px 15px;
  width: 25%;
  min-width: 305px;
}

.transac-cards-selected {
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.97),
      rgba(255, 255, 255, 0.97)
    ),
    #18a41d;
  box-shadow: 0px 4px 10px rgba(196, 196, 196, 0.1);
  border-radius: 8px;
}

.h-one {
  height: 65px;
}

.h-two {
  height: 40px;
}

.setfirst-img {
  position: absolute;
  bottom: 0px;
  right: 0px;
}

.setsecond-img {
  position: absolute;
  top: 0px;
  right: 0px;
}

.selected-green-text {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 22px;
  line-height: 26px;

  color: #3d8200;
}

.selected-small-text {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;

  color: #3d8200;
}

.big-line {
  border: 1px solid #c4c4c480;
  height: 150px;
}

.head-text {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 22px;
  line-height: 26px;

  color: #72738e;
}

.subhead-text {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #72738e;
}

.creadits-head {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
}

.credits-subhead {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #72738e;
}

.transac-main-table {
  background: #fff;
  box-shadow: 0px 0px 18px 0px #00000029;
  border-radius: 8px;
  padding: 10px 15px;
  height: calc(100vh - 356px);
}

.transac-main-head {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
  color: #000000;
}

.transac-main-inner-table {
  overflow-x: auto;
  overflow-y: hidden;
}

.transac-table-head {
  min-width: 1300px;
  max-width: 100%;
  background: #e9f0f5;
  border-radius: 3px;
  display: flex;
  align-items: center;
  padding: 10px 0px;
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: var(--size-14);
  color: #20639b;
  z-index: 2;
  position: relative;
}

.transac-table-body {
  min-width: 1300px;
  max-width: 100%;
  overflow-y: auto;
  height: calc(100vh - 560px);
}

.transac-table-row {
  width: 100%;
  position: relative;
  border-radius: 3px;
  border: 0.5px solid #e5e5e5;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #20639b;
  padding: 12px 0px;
  margin: 6px 0px;
  font-family: "Lato", sans-serif;
}

.transaction-paginaTion-new {
  min-width: 1300px !important;
  max-width: 100% !important;
}

.yellow-card {
  background: #ffb750;
  border-radius: 5px;
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ffffff;
  padding: 2px 12px;
  width: fit-content;
  height: fit-content;
}

.blue-card {
  padding: 2px 12px;
  background: rgba(32, 99, 155, 0.2);
  border-radius: 32px;
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  width: fit-content;
  height: fit-content;
}

.light-yellow-card {
  padding: 2px 12px;
  background: rgba(254, 216, 67, 0.32);
  border-radius: 32px;
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  width: fit-content;
  height: fit-content;
}

.daily-option {
  position: relative;
}

/* Filter popup styles */
.filter-popup {
  position: absolute;
  top: 100%;
  right: 0%;
  padding: 15px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 0 15px #10101021;
  display: flex;
  flex-direction: column;
  z-index: 300;
  width: 280px;
  margin-top: 5px;
}

.acs-black-txt {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.acs-filter-dropdown {
  width: 100%;
  background: #ffffff;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
}

.newManage-dropdown-place {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #333;
}

.newInt-radio-dropdown {
  position: absolute;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(196, 196, 196, 0.6);
  z-index: 300;
  border-radius: 5px;
}

.newInt-radio-dropdown-inner-content label {
  width: 100%;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #333;
  padding: 8px 15px;
  border-bottom: 1px solid #e5e5e5;
  margin: 0;
}

.newInt-radio-dropdown-inner-content label:hover {
  background: #e8eff4;
}
.rotate-180 {
  transform: rotate(180deg);
}
.nodta-txt {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #3a3c40;
}
.tooltip-pos {
  right: unset !important;
  top: 172px !important;
}
</style>
